export enum AnalyzeUnitType {
  Mwh = 'mwh',
  Kwh = 'kwh',
  M3 = 'm3',
  Celsius = 'C',
  Kw = 'kw',
  Kr = 'Kr'
}
